const wowApp = require('angular').module('wowApp.shop');

wowApp.service('ShelfProductService', ['Restangular', 'DetailProductService', 'TrolleyService', require('./shelfproduct.service')]);
wowApp.service('DetailProductService', ['Restangular', '$rootScope', 'BreakpointsService', require('./shelfproduct-detail.service')]);

wowApp.component('wowShelfBundleTile', require('./shelf-bundle-tile.component').shelfBundleTileComponentDefinition);
wowApp.component('wowShelfProductVariant', require('./shelf-product-variant.component').shelfProductVariantComponentDefinition);

wowApp.component('wowShelfProductTile', require('./shelf-product-tile.component').shelfProductTileComponentDefinition);
wowApp.component('wowShelfProductList', require('./shelf-product-list.component').shelfProductListComponentDefinition);
wowApp.component('wowShelfProductTileOffer', require('./shelf-product-tile-offer.component').shelfProductTileOfferComponentDefinition);
wowApp.component('wowShelfProductListOffer', require('./shelf-product-list-offer.component').shelfProductListOfferComponentDefinition);
wowApp.component('wowShelfProductTagCenter', require('./shelf-product-tag/shelf-product-tag-center.component').shelfProductTagCenterComponentDefinition);
wowApp.component('wowShelfProductTagImage', require('./shelf-product-tag/shelf-product-tag-image.component').shelfProductTagImageComponentDefinition);



// WEBPACK FOOTER //
// ./src/shop/shelfproduct/index.js